/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { shareViaMsTeams, shareViaOutlook } from './constants';

const shareByOutlook = (
  mailSubject: string,
  messageText: string,
  url: string,
) => {
  const mailBody = `${messageText}\n\n${url}`;
  window.location.href = `mailto:?subject=${encodeURIComponent(
    mailSubject,
  )}&body=${encodeURIComponent(mailBody)}`;
};

const shareByMsTeams = (url: string, msgText: string) => {
  window.open(
    `https://teams.microsoft.com/share?href=${url}&msgText=${msgText}`,
    'ms-teams-share-popup',
    'width=700,height=600',
  );
};

export const shareInOutlookAndTeams = (
  shareVia: string,
  subjectText: string,
  bodyText: string,
  url: string,
) => {
  switch (shareVia) {
    case shareViaMsTeams:
      shareByMsTeams(url, bodyText);
      break;
    case shareViaOutlook:
      shareByOutlook(subjectText, bodyText, url);
      break;
    default:
      break;
  }
};
